module.exports = __webpack_public_path__ + "img/Triangle.050e4b06.svg";